<template>
    <div class="container-fluid d-flex flex-column">
        <div class="row justify-content-center min-vh-100">
            <div class="col-md-6 col-lg-5 col-xl-4 py-6 py-md-0 mt-5">
                <div class="card" style="max-width: 600px; margin: 0 auto;">
                    <div class="d-flex justify-content-end mr-2 mt-1">
                        <LanguageSwitcher />
                    </div>

                    <div class="card-body">
                        <div class="card-header"></div>

                        <div>
                            <div class="mb-5 text-center">
                                <CompanyImage :type="CompanyImageType.Logo" max-height="140px" max-width="100%" />
                            </div>

                            <span class="clearfix"></span>

                            <div v-if="!successful">
                                <ResetPasswordForm
                                    v-if="initialized"
                                    :initial-values="request"
                                    id="reset-password-form"
                                    @submit="submitResetPassword"
                                    @clear-error="errorMessage = null"
                                />
                                <button type="submit" form="reset-password-form" class="btn btn-block btn-primary mt-4">{{ $t('register.reset_password_title') }}</button>
                            </div>

                            <div class="mt-5" v-if="successful || errors.length || errorMessage">
                                <div class="alert alert-success" v-if="successful">
                                    {{ $t('register.password_reset_success_message' + (countdown === 0 ? '_redirecting' : ''), { countdown }) }}
                                </div>

                                <div class="alert alert-danger" v-if="errors.length">
                                    <ul>
                                        <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
                                    </ul>
                                </div>

                                <div class="alert alert-danger" v-if="errorMessage">{{ errorMessage }}</div>
                            </div>

                            <div class="mt-3 text-center">
                                <router-link to="/login">{{ $t('register.login_link') }}</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ResetPasswordForm from '../forms/ResetPasswordForm.vue';
    import LanguageSwitcher from '../components/LanguageSwitcher.vue';
    import CompanyImage from './CompanyImage.vue';
    import { CompanyImageType } from '../enums/company-image-type';

    export default {
        computed: {
            CompanyImageType() {
                return CompanyImageType;
            },
        },
        components: {
            CompanyImage,
            LanguageSwitcher,
            ResetPasswordForm,
        },

        data() {
            return {
                initialized: false,
                request: {
                    email: '',
                    password: '',
                    password_confirmation: '',
                },
                successful: false,
                errorMessage: null,
                countdownInterval: null,
                errors: [],
                countdown: 5,
            };
        },

        mounted() {
            this.request.email = this.$route.query.email || '';
            this.initialized = true;
        },

        methods: {
            async submitResetPassword(data) {
                try {
                    await this.$http.post('/api/password/reset', {
                        ...data,
                        token: this.$route.query.token,
                    });

                    this.successful = true;
                    this.countdown = 5;

                    this.countdownInterval = setInterval(() => {
                        this.countdown--;

                        if (this.countdown === 0) {
                            if (this.countdownInterval) {
                                clearInterval(this.countdownInterval);
                            }

                            this.$router.push({
                                name: 'login',
                            });
                        }
                    }, 1000);
                } catch (exception) {
                    this.handleErrorResponse(exception.response);
                }
            },

            handleErrorResponse(response) {
                if (response.status === 400 || response.status === 404) {
                    this.errorMessage = this.$t('register.token_not_found');
                } else if (response.status === 422) {
                    this.errors = Object.values(response.data.errors).flat();
                } else {
                    this.errorMessage = this.$t('general.unexpected_error');
                }
            },
        },
    };
</script>
